/// <reference path="../_references.ts"/>

module App.ItemManagement {
	import Questionnaire = App.Questionnaire.Questionnaire;

	export class ServiceableItem {
		[key: string]: any;

		id: number;
		serviceable_item_type: ServiceableItemType;
		notes: ServiceableItemNote[];
		location: string;
		make: string;
		model_number: string;
		serial_number: string;
		installed_on: Date;
		in_service: boolean;
		maintained: boolean;
		images: ServiceableItemImage[];
		organization: number;
		service_request: {id: number};
		last_serviced: Date;
		tag_1: TagOption;
		tag_2: TagOption;
		tag_3: TagOption;
		tag_4: TagOption;
		tag_5: TagOption;
		tag_6: TagOption;
		tag_7: TagOption;
		tag_8: TagOption;
		tag_9: TagOption;

		age: string;
		service_requests: { id: number }[];

		constructor(data?: ServiceableItem) {
			data = data || this;

			if(data.installed_on != null) {
				this.installed_on = moment(data.installed_on).toDate();

				let ms = moment().diff(this.installed_on);
				let duration = moment.duration(ms);

				this.age = '';
				this.age += this.timeString(duration.years(), 'Year');
				if(duration.months() > 0) {
					if (this.age) {
						this.age += ', '
					}
					this.age += this.timeString(duration.months(), 'Month');
				}
			}
			if(data.last_serviced != null) {
				this.last_serviced = moment(data.last_serviced).toDate();
			}

			this.id = data.id;
			this.serviceable_item_type = data.serviceable_item_type;
			this.notes = data.notes;
			this.location = data.location;
			this.model_number = data.model_number;
			this.serial_number = data.serial_number;
			this.in_service = data.in_service;
			this.maintained = data.maintained;
			this.images = data.images;
			this.organization = data.organization;
			this.service_request = data.service_request;
			this.tag_1 = data.tag_1;
			this.tag_2 = data.tag_2;
			this.tag_3 = data.tag_3;
			this.tag_4 = data.tag_4;
			this.tag_5 = data.tag_5;
			this.tag_6 = data.tag_6;
			this.tag_7 = data.tag_7;
			this.tag_8 = data.tag_8;
			this.tag_9 = data.tag_9;
			this.make = data.make;
			this.service_requests = data.service_requests;
		}

		private timeString(val: number, period: string) {
			if(val > 0) {
				return val + ' ' + period + (val > 1 ? 's' : '');
			}
			return '';
		}
	}

	export type ServiceableItemCreate = {
		address: number,
		customer: number,
		serviceable_item_type: number,
		created_service_request?: number,
		in_service: boolean,
		maintained: boolean
	}

	export type ServiceableItemType = {
		id: number,
		visible: boolean,
		cost: number,
		frequency: string,
		replacement_years: number,
		maintenance_months: number,
		organization: number,
		questionnaires: Questionnaire[],
		name: string,
		description: string
	}

	export type ServiceableItemNote = {
		id?: number,
		description: string,
		organization?: number,
		service_request?: number
	}

	export type ServiceableItemImage = {
		id?: number,
		url: string,
		pdf_url: string,
		organization: number,
		created: string
	}

	export type ServiceableItemTag = {
		id: number,
		options: string[],
		name: string,
		tag_group: number
	}

	export type Tag = {
		options: TagOption[],
		name: string
	}

	export type TagOption = {
		index: number,
		value: string
	}
}